import { useEffect, useRef, useState } from "react";
import { RoomSheet } from "./RoomSheet";

export const RoomSheetPreview = ({ room, sheetRef }) => {
  const stageRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const stage = stageRef.current;
    if (!stage) return undefined;
    const update = () => setScale(Math.min(stage.clientWidth / 816, 1));
    update();
    const observer = new ResizeObserver(update);
    observer.observe(stage);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={stageRef} className="room-sheet-stage" style={{ height: `${1056 * scale}px` }}>
      <div className="room-sheet-scale" style={{ transform: `scale(${scale})` }}>
        <RoomSheet ref={sheetRef} room={room} />
      </div>
    </div>
  );
};